import { fetchWithAuth } from "./api-client"
import Swal from "sweetalert2"
import { isOnline } from "./networkBus"

// Add the restaurant to the database if user confirms they are at the restaurant
async function addNewRestaurant(name, position) {
	try {
		const response = await fetchWithAuth("/api/add-new-restaurant", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				restaurantName: name,
				latitude: position.latitude,
				longitude: position.longitude,
			}),
		})

		const result = await response.json()
		if (result.error) {
			console.error("Error adding restaurant:", result.error)
		} else {
			console.log("Restaurant added successfully:", result.restaurant)
		}
	} catch (error) {
		console.error("Failed to add restaurant:", error)
	}
}

export default async function checkNewRestaurant(cookType, restaurant) {
	// Check if this is a custom restaurant that's not in our database
	if (
		isOnline.value &&
		cookType === "restaurant" &&
		restaurant &&
		restaurant.isCustom &&
		restaurant.position &&
		restaurant.position.latitude &&
		restaurant.position.longitude
	) {
		// Ask the user if they are currently at this restaurant
		const result = await Swal.fire({
			title: "Are you at this restaurant now?",
			text: `We don't have "${restaurant.name}" in our database. Are you currently at this location?`,
			icon: "question",
			showCancelButton: true,
			confirmButtonText: "Yes, I am here",
			cancelButtonText: "No",
			reverseButtons: true,
		})

		// If user confirms they are at the restaurant,
		// add it to the database with current coordinates
		if (result.isConfirmed) {
			//run in background
			addNewRestaurant(restaurant.name, restaurant.position)
		}
	}
}
